(() => {
  const normalize = value => String(value || '').toLocaleLowerCase('nb-NO').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/æ/g,'ae').replace(/ø/g,'o').replace(/[^a-z0-9]+/g,' ').trim();
  const stop = new Set(normalize('jeg vi du dere trenger vil ønsker har en et ei til for og i på av med som det den de finne etter meg oss noe skal kjøpe kan hva hvor hvilken hjelp leter beste bra gjerne bruke brukes ha er skal må min mitt mine deres rundt fra etter bare cirka ca ønsker søker').split(' '));
  const groups = [
    ['hanske','hansker','arbeidshanske','arbeidshansker','hagehansker','håndvern'],
    ['garasjelys','garasjebelysning','garasje','garasjen','industriarmatur','tysnes'],['armatur','armaturer'],
    ['lyspære','lyspærer','pære','pærer','lyskilde','lyskilder'],['hodelykt','pannelykt','hodelampe'],
    ['arbeidslampe','arbeidslys','arbeidsbelysning'],['søppelpose','søppelposer','avfallspose','avfallsposer','søppelsekk','avfallssekk','søppelsekker','avfallssekker'],
    ['kaffe','kaffepulver','frokostkaffe','filterkaffe'],['bilvask','bilpleie','bilsåpe','bilshampo','bilvaskemiddel'],
    ['starthjelp','startbooster','batteribooster','startkabler'],['spennbånd','lastsikring','lastestropp','lastestropper','jekkestropp'],
    ['termostat','termostater','varmestyring'],['dimmer','dimmere','lysdimmer'],['vernebrille','vernebriller','beskyttelsesbriller','øyebeskyttelse'],
    ['hørselvern','øreklokker','ørepropper'],['mikrofiberklut','mikrofiberkluter','vaskeklut'],['vinterjakke','vinterjakker','arbeidsjakke','arbeidsjakker'],
    ['bits','bitsett','bitssett'],['strips','kabelstrips','kabelbånd'],['stikkontakt','stikkontakter','stikk'],['smartplugg','smartkontakt','smartstøpsel'],
    ['målebånd','tommestokk','målestokk'],['slangetrommel','hageslange','hageslangesett','hagevanning','vanning','vanne','vanningspistol','sprinklerpistol'],
    ['kaldavfetting','asfaltfjerner','tjærefjerner'],['rustløser','rustfjerner'],['smarthus','smartstyring','plejd','smartplugg'],
    ['elektro','koblingsklemme','stikkontakt','bryter','dimmer','termostat'],['verktøy','verktøysett','hammer','tang','bitssett'],
    ['renhold','rengjøring','rengjøringsmiddel','rengjøringsmidler','vaskemiddel','vaskemidler'],['feiekost','feiesett','kost','feiebrett'],
    ['lykt','lykte','lommelykt','hodelykt'],['brannvern','brannslukker','brannslukningsapparat','røykvarsler'],
    ['bil','bilutstyr','bilpleie','starthjelp','lastsikring','isskrape','snøbørste'],
    ['belysning','lys','lampe','armatur','taklampe','spotlight'],['beskyttelse','verneutstyr','arbeidshanske','vernebrille']
  ].map(g=>g.map(normalize));
  const tokens = value => [...new Set(normalize(value).split(' ').filter(t=>t.length>1&&!stop.has(t)))];
  const stem = value => value.length>5?value.replace(/(ene|eren|erne|ende|er|en|et)$/,''):value;
  const close = (a,b) => {
    if(a.length<5||b.length<5||Math.abs(a.length-b.length)>1)return false;
    let i=0,j=0,n=0;
    while(i<a.length&&j<b.length){if(a[i]===b[j]){i++;j++;continue;}if(++n>1)return false;if(a.length>=b.length)i++;if(b.length>=a.length)j++;}
    return n+a.length-i+b.length-j<=1;
  };
  const cache=new WeakMap();
  const prepare=products=>{
    if(cache.has(products))return cache.get(products);
    const rows=products.map(p=>({p,title:tokens(p.t),head:tokens(p.t+' '+p.k+' '+p.v+' '+(p.o||'')),details:new Set(tokens(p.d+' '+(p.g||[]).join(' '))),ids:(p.s||[]).filter(Boolean).map(x=>normalize(x).replace(/ /g,''))}));
    cache.set(products,rows);return rows;
  };
  const interpret=query=>{
    let text=String(query||'').toLocaleLowerCase('nb-NO').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/æ/g,'ae').replace(/ø/g,'o').replace(/[^a-z0-9., ]/g,' ').replace(/\s+/g,' ').trim(),min=0,max=Infinity,size=null;
    const amount='(\\d+(?:[ .,]\\d{3})*(?:[,.]\\d{1,2})?)';
    const number=s=>Number(s.replace(/\s/g,'').replace(/\.(?=\d{3}(?:\D|$))/g,'').replace(',','.'));
    text=text.replace(new RegExp('(?:under|maks|maksimum|opptil|inntil) '+amount+'(?: kr| kroner| nok)?','g'),(_,n)=>{max=number(n)*100;return '';});
    text=text.replace(new RegExp('(?:over|minst|minimum|fra) '+amount+'(?: kr| kroner| nok)','g'),(_,n)=>{min=number(n)*100;return '';});
    text=text.replace(/(?:storrelse|str\.?)\s*(\d{1,2}|xxxl|xxl|xl|xs|s|m|l)\b/g,(_,n)=>{size=n;return '';});
    const colors=[['svart','sort','black'],['hvit','white'],['rod','red'],['bla','blue'],['gronn','green'],['gul','yellow'],['gra','grey','gray']];
    const color=colors.find(g=>g.some(w=>new RegExp('\\b'+w+'\\b').test(text)));
    if(color)text=text.replace(new RegExp('\\b('+color.join('|')+')\\b','g'),'');
    const cheap=/\b(billigst|billigste|rimeligst|laveste pris)\b/.test(text);
    text=text.replace(/\b(billigst|billigste|rimeligst|laveste pris|budsjett)\b/g,'').trim();
    return {text:normalize(text),min,max,size,color,cheap};
  };
  const matchesConstraints=(p,c)=>{
    if(p.c<c.min||p.c>c.max)return false;
    const head=normalize(p.t+' '+(p.o||''));
    if(c.color&&!c.color.some(w=>new RegExp('\\b'+w+'\\b').test(head)))return false;
    if(c.size&&!new RegExp('(?:storrelse|str) ?'+c.size+'\\b').test(head)&&!new RegExp('\\b'+c.size+'\\b').test(normalize(p.o)))return false;
    return true;
  };
  const rankRaw=(products,query)=>{
    const terms=tokens(query),full=normalize(query),compact=full.replace(/ /g,'');if(!terms.length)return [];
    const extra=[];
    if(/(fjerne|vaske).*(asfalt|tjaere)/.test(full))extra.push('kaldavfetting');
    if(/(starte|start).*(bil|batteri)/.test(full))extra.push('starthjelp');
    const search=[...new Set([...terms,...extra])];
    const expanded=search.map(t=>new Set([t,...groups.filter(g=>g.includes(t)).flat()]));
    const familyTerm=search.find(t=>groups.some(g=>g.includes(t)));
    const family=familyTerm?new Set([familyTerm,...groups.filter(g=>g.includes(familyTerm)).flat()]):null;
    const rows=prepare(products),df=search.map(t=>rows.filter(r=>r.head.includes(t)||r.details.has(t)).length);
    const ranked=rows.map(r=>{
      if(normalize(r.p.t)===full)return {p:r.p,score:10000};
      if(compact.length>=4&&r.ids.includes(compact))return {p:r.p,score:9000};
      if(family&&!r.head.some(t=>[...family].some(w=>t===w||stem(t)===stem(w)||(w.length>=5&&t.endsWith(w)))))return null;
      let score=0,matched=0,strong=0;
      expanded.forEach((words,i)=>{
        const term=search[i],weight=1+Math.log(1+products.length/(1+df[i]));let n=0;
        if(r.ids.includes(term)&&term.length>=4)n=100;
        else if(r.head.includes(term))n=r.title.includes(term)?15:12;
        else if(r.head.some(t=>stem(t)===stem(term)))n=10;
        else if(r.head.some(t=>words.has(t)||[...words].some(w=>w.length>=5&&t.endsWith(w))))n=8;
        else if(r.head.some(t=>t.startsWith(term)&&term.length>=4))n=7;
        else if(r.head.some(t=>close(term,t)))n=5;
        else if(r.details.has(term))n=df[i]<products.length*.15?4:1;
        if(n){score+=n*weight;matched++;if(n>=4)strong++;}
      });
      if(!strong)return null;
      score*=.5+.5*matched/search.length;
      if(full.includes(' ')&&normalize(r.p.t).includes(full))score+=60;
      return {p:r.p,score};
    }).filter(Boolean).sort((a,b)=>b.score-a.score||a.p.t.localeCompare(b.p.t,'nb'));
    const threshold=(ranked[0]?.score||0)*.45;
    return ranked.filter(x=>x.score>=threshold).map(x=>x.p);
  };
  const rank=(products,query)=>{
    if(products.some(p=>normalize(p.t)===normalize(query)))return rankRaw(products,query);
    const c=interpret(query),constrained=c.color||c.size||c.min||Number.isFinite(c.max);
    const eligible=constrained?products.map(p=>{
      if(!p.x)return matchesConstraints(p,c)?p:null;
      const variants=p.x.filter(v=>matchesConstraints({...p,o:v.t,c:v.c},c)).sort((a,b)=>a.c-b.c);
      if(!variants.length)return null;
      const v=variants[0];return {...p,o:v.t,c:v.c,a:v.a,pv:false,vi:v.id};
    }).filter(Boolean):products;
    const result=rankRaw(eligible,c.text);
    if(c.cheap)result.sort((a,b)=>a.c-b.c);
    return result;
  };
  let catalogPromise,catalogTime=0;
  const loadCatalog=()=>{
    if(catalogPromise&&Date.now()-catalogTime<120000)return catalogPromise;
    catalogTime=Date.now();
    catalogPromise=(async()=>{
      const page=async n=>{const root=window.Shopify?.routes?.root||'/';const r=await fetch(root+'collections/all?view=dugnado-finder&page='+n,{signal:AbortSignal.timeout(15000)});if(!r.ok)throw Error('catalog');return r.json();};
      const first=await page(1),all=[...first.products];
      for(let n=2;n<=first.pages;n+=4){const batch=await Promise.all(Array.from({length:Math.min(4,first.pages-n+1)},(_,j)=>page(n+j)));batch.forEach(p=>all.push(...p.products));}
      const unique=[...new Map(all.map(p=>[p.h,p])).values()];if(unique.length!==first.total)throw Error('catalog changed');return unique;
    })().catch(e=>{catalogPromise=null;throw e;});return catalogPromise;
  };
  const helpLinks=query=>{
    const q=normalize(query),links=[];
    if(/retur|angre|reklamasjon|refusjon/.test(q))links.push({title:'Retur og angrerett',path:'policies/refund-policy'});
    if(/frakt|levering|gebyr|smaordre/.test(q))links.push({title:'Levering og småordregebyr',path:'policies/shipping-policy'});
    if(/\b(kontakt|kundeservice|telefon|epost|e post)\b/.test(q))links.push({title:'Kontakt oss',path:'pages/contact'});
    return links;
  };
  const brand=p=>{
    if(p.v&&normalize(p.v)!=='dugnado')return p.v;
    const explicit=['Guide','Workhand','Ironside','Bona','Ajax','SG','Plejd','Tork','Tegera','CRC','Hozelock','Vikan','Granberg','Kron','Motala','3M','Structron','Kemetyl','Sun','Grumme','Nordex','Plum','Housegard','Gelia','Thorn'];
    return explicit.find(name=>normalize(p.t).startsWith(normalize(name)+' '))||'';
  };
  const api={rank,normalize,interpret,loadCatalog,helpLinks,brand};globalThis.DugnadoMatch=api;if(typeof module!=='undefined')module.exports=api;
})();
